import React, {FC} from 'react';

import styles from './RequestLoader.module.css';

export interface RequestLoaderProps {
	size?: number;
	invert?: boolean;
}

export const RequestLoader: FC<RequestLoaderProps> = ({size, invert}) => (
	<div
		style={{width: size, height: size}}
		className={`${styles.loader}${invert ? ` ${styles.invert}` : ''}`}
	>
		<div className={styles.circle} />
		<div className={styles.circle} />
		<div className={styles.circle} />
		<div className={styles.circle} />
	</div>
);
